import React, { useState } from 'react';
import styled from '@emotion/styled';
import { useRelativeDate } from '~/react-hooks/use-date';
import Button, { BootstrapButton } from '~/App/Components/Button';
import hexToRgba from 'hex-to-rgba';
import colours from '~/utils/colours';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { assetUrl } from '~/helpers';

const StyledVideoWrapper = styled.div`
  position: relative;
  margin-right: 25px;
  width: 90px;
  height: 90px;
`;

const StyledPlayIcon = styled.img`
  position: absolute;
  width: 40%;
  height: 40%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
`;

const StyledLoadingWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.1);
`;

interface ListGroupItemProps {
  active: boolean;
}

const StyledRightContent = styled.div`
  visibility: hidden;
  margin-left: auto;
`;

const ListGroupItem = styled.li<ListGroupItemProps>`
  display: flex;
  align-items: center;
  cursor: pointer;
  ${(props) => {
    if (props.active) {
      return `background-color: ${hexToRgba(colours.blue, 0.2)};`;
    }
  }}

  justify-content: space-between;
  border: unset;
  position: relative;
  padding: 15px;
  border-bottom: 1px solid ${colours.greyMedium};

  &:hover {
    background-color: ${(props) =>
      props.active ? hexToRgba(colours.blue, 0.2) : colours.formBgGrey};

    ${StyledRightContent} {
      visibility: visible;
    }
  }
`;

const StyledVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const StyledTitle = styled.div`
  margin-bottom: 5px;
  color: #333333;
`;

const StyledDateCreated = styled.div`
  color: #666666;
`;

export interface VideoItemProps {
  id: string;
  videoUrl: string;
  title: string;
  dateCreated: string;
  onDelete: (id: string) => void;
  onClick: (id: string) => void;
  active: boolean;
}

const VideoItem = ({
  id,
  videoUrl,
  title,
  dateCreated,
  onDelete,
  onClick,
  active,
}: VideoItemProps) => {
  const [isPreviewLoaded, setIsPreviewLoaded] = useState(false);
  const relativeDate = useRelativeDate(dateCreated);

  const handleDeleteClick = (e: React.MouseEvent<BootstrapButton>) => {
    e.stopPropagation();
    onDelete(id);
  };

  return (
    <ListGroupItem key={videoUrl} active={active} onClick={() => onClick(id)}>
      <StyledVideoWrapper>
        <StyledVideo onLoadedData={() => setIsPreviewLoaded(true)}>
          <source src={videoUrl} />
        </StyledVideo>
        {!isPreviewLoaded ? (
          <StyledLoadingWrapper>
            <FontAwesomeIcon spin icon={faSpinner} />
          </StyledLoadingWrapper>
        ) : (
          <StyledPlayIcon
            src={assetUrl('assets/images/icons/message-template/Playicon.svg')}
          />
        )}
      </StyledVideoWrapper>
      <div>
        <StyledTitle>{title}</StyledTitle>
        <StyledDateCreated>{relativeDate}</StyledDateCreated>
      </div>
      <StyledRightContent>
        <Button onClick={handleDeleteClick}>Delete</Button>
      </StyledRightContent>
    </ListGroupItem>
  );
};

export default VideoItem;
